import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { LoadingOptions } from '@ionic/core';

import { Constants } from 'uApp/app.constants';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  public loading: any = undefined;
  public defaultContent: string = 'Loading';

  private loader: any;
  private loaderLoading = false;

  constructor(public spinner: LoadingController) { }

  public showSpinner({ duration = Constants.SPINNER_DURAION,
                       message = this.defaultContent
                     }: LoadingOptions): void {
    // console.log('>>>>showSpinner>>> this.loader -', !!this.loader, ' , this.loaderLoading - ', !!this.loaderLoading);
    if (!this.loader && !this.loaderLoading) {
      this.loaderLoading = true;
      this.spinner.create({
        spinner: 'bubbles',
        // message: message,
        duration,
        cssClass: 'global-spinner'
      }).then((loader) => {
        this.loader = loader;
        this.loader.present().then(() => {
          this.loaderLoading = false;
          try {
            if (!!this.loader) { this.loader.onDidDismiss(() => {
              this.loader = undefined;
              console.log('>>>>hideSpinner>>> onDidDismiss - this.loading', this.loader);
            }); }
          } catch (e) {
            console.log('>>>>hideSpinner>>> onDidDismiss - error: ', e);
          }

        });
      });
    }
  }

  public hideSpinner(): void {
    const interval = setInterval(() => {
      if (!!this.loader) {
        try {
          this.loader.dismiss().then(() => {
            console.log('>>>>hideSpinner>>> dismiss');
            this.loader = undefined;
            clearInterval(interval);
          }).catch((error: any) => {
            console.log('>>>>hideSpinner>>> error:', error);
          });
        } catch (e) {
          console.log('>>>>hideSpinner>>> catch error:', e);
        }
      } else if (!this.loader && !this.loaderLoading) {
        clearInterval(interval);
      }
    }, 500);
  }
}
